var t="stratum_default_correlation_id",r="stratumdb";export{t as STORED_CORRELATION_ID_KEY,r as WINDOW_DEBUG_FLAG_KEY};
